import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';

const ExamCellAdmitCard = ({ onNavigate, userInfo }) => {
    // ====================================================================================================
    // STATE MANAGEMENT
    // ====================================================================================================
    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(true);

    // Filters
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCourse, setSelectedCourse] = useState('All');
    const [selectedSemester, setSelectedSemester] = useState('All');
    const [statusFilter, setStatusFilter] = useState('All');

    // Selection & Bulk Actions
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [processingBulk, setProcessingBulk] = useState(false);

    // Modals
    const [previewStudent, setPreviewStudent] = useState(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

    // Notification
    const [notification, setNotification] = useState(null);

    // ====================================================================================================
    // MOCK DATA
    // ====================================================================================================
    const [students, setStudents] = useState([
        {
            id: 'STU001',
            name: 'Rahul Kumar',
            rollNo: '24BCA001',
            course: 'BCA',
            semester: '3rd',
            examCenter: 'Main Hall A',
            status: 'Generated',
            photo: 'url_to_photo',
            subjects: ['BCA301', 'BCA302', 'BCA303', 'BCA304', 'BCA305']
        },
        {
            id: 'STU002',
            name: 'Priya Sharma',
            rollNo: '24BCA002',
            course: 'BCA',
            semester: '3rd',
            examCenter: 'Main Hall A',
            status: 'Pending',
            photo: 'url_to_photo',
            subjects: ['BCA301', 'BCA302', 'BCA303', 'BCA304', 'BCA305']
        },
        {
            id: 'STU003',
            name: 'Amit Patel',
            rollNo: '25MCA001',
            course: 'MCA',
            semester: '1st',
            examCenter: 'Hall B',
            status: 'Generated',
            photo: 'url_to_photo',
            subjects: ['MCA101', 'MCA102', 'MCA103', 'MCA104']
        },
        // Generating more students
        ...Array.from({ length: 20 }).map((_, i) => ({
            id: `STU${100 + i}`,
            name: `Student Name ${i + 1}`,
            rollNo: `${24 + (i % 2)}${i % 2 === 0 ? 'BCA' : 'MCA'}0${10 + i}`,
            course: i % 2 === 0 ? 'BCA' : 'MCA',
            semester: i % 2 === 0 ? '3rd' : '1st',
            examCenter: i % 2 === 0 ? 'Main Hall A' : 'Hall B',
            status: i % 3 === 0 ? 'Pending' : 'Generated',
            photo: 'url_to_photo',
            subjects: ['SUB001', 'SUB002', 'SUB003']
        }))
    ]);

    // ====================================================================================================
    // EFFECTS
    // ====================================================================================================
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        setTimeout(() => setLoading(false), 800);
    }, []);

    // ====================================================================================================
    // ACTIONS
    // ====================================================================================================

    const toggleSelectAll = () => {
        if (isAllSelected) {
            setSelectedStudents([]);
            setIsAllSelected(false);
        } else {
            setSelectedStudents(filteredStudents.map(s => s.id));
            setIsAllSelected(true);
        }
    };

    const toggleSelectStudent = (id) => {
        if (selectedStudents.includes(id)) {
            setSelectedStudents(selectedStudents.filter(sid => sid !== id));
            setIsAllSelected(false);
        } else {
            setSelectedStudents([...selectedStudents, id]);
        }
    };

    const handleBulkGenerate = () => {
        if (selectedStudents.length === 0) return;
        setProcessingBulk(true);
        setTimeout(() => {
            const updatedStudents = students.map(s =>
                selectedStudents.includes(s.id) ? { ...s, status: 'Generated' } : s
            );
            setStudents(updatedStudents);
            setProcessingBulk(false);
            setSelectedStudents([]);
            setIsAllSelected(false);
            setNotification({ message: `Successfully generated ${selectedStudents.length} admit cards`, type: 'success' });
            setTimeout(() => setNotification(null), 3000);
        }, 1500);
    };

    const handlePreview = (student) => {
        setPreviewStudent(student);
        setIsPreviewModalOpen(true);
    };



    // ====================================================================================================
    // FILTERING
    // ====================================================================================================
    const filteredStudents = students.filter(s => {
        const matchesSearch =
            s.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            s.rollNo.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesCourse = selectedCourse === 'All' || s.course === selectedCourse;
        const matchesSemester = selectedSemester === 'All' || s.semester === selectedSemester;
        const matchesStatus = statusFilter === 'All' || s.status === statusFilter;
        return matchesSearch && matchesCourse && matchesSemester && matchesStatus;
    });

    // ====================================================================================================
    // UI COMPONENTS
    // ====================================================================================================

    const PreviewModal = () => {
        if (!previewStudent) return null;
        return (
            <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 1100,
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                overflowY: 'auto', padding: '1rem'
            }}>
                <div style={{
                    background: '#fff', width: '100%', maxWidth: '800px',
                    borderRadius: '8px', boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
                    position: 'relative'
                }}>
                    <div style={{ padding: '1rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3 style={{ margin: 0, color: '#238548' }}>Admit Card Preview</h3>
                        <button onClick={() => setIsPreviewModalOpen(false)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666' }}>✕</button>
                    </div>

                    <div style={{ padding: '2rem', background: '#fff', border: '1px solid #000', margin: '1rem' }}>
                        <div style={{ textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '1rem', marginBottom: '1.5rem' }}>
                            <h2 style={{ margin: '0 0 0.5rem 0', textTransform: 'uppercase', color: '#000' }}>Swami Vivekananda University</h2>
                            <h4 style={{ margin: 0, color: '#000' }}>Term End Examination 2026</h4>
                            <h3 style={{ margin: '0.5rem 0 0 0', textDecoration: 'underline', color: '#000' }}>ADMIT CARD</h3>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '4fr 1fr', gap: '2rem', marginBottom: '1.5rem' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '1rem', rowGap: '0.5rem', color: '#000' }}>
                                <div style={{ fontWeight: 'bold' }}>Name:</div><div>{previewStudent.name}</div>
                                <div style={{ fontWeight: 'bold' }}>Roll No:</div><div>{previewStudent.rollNo}</div>
                                <div style={{ fontWeight: 'bold' }}>Course:</div><div>{previewStudent.course}</div>
                                <div style={{ fontWeight: 'bold' }}>Semester:</div><div>{previewStudent.semester}</div>
                                <div style={{ fontWeight: 'bold' }}>Exam Center:</div><div>{previewStudent.examCenter}</div>
                            </div>
                            <div style={{ border: '1px solid #000', height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000' }}>
                                Photo
                            </div>
                        </div>

                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000', marginBottom: '2rem' }}>
                            <thead>
                                <tr style={{ borderBottom: '1px solid #000' }}>
                                    <th style={{ border: '1px solid #000', padding: '0.5rem', color: '#000' }}>Subject Code</th>
                                    <th style={{ border: '1px solid #000', padding: '0.5rem', textAlign: 'left', color: '#000' }}>Subject Name</th>
                                    <th style={{ border: '1px solid #000', padding: '0.5rem', color: '#000' }}>Invigilator Sign</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: '#000' }}>
                                {previewStudent.subjects.map((sub, i) => (
                                    <tr key={i}>
                                        <td style={{ border: '1px solid #000', padding: '0.5rem', textAlign: 'center' }}>{sub}</td>
                                        <td style={{ border: '1px solid #000', padding: '0.5rem' }}>Subject Name Placeholder</td>
                                        <td style={{ border: '1px solid #000', padding: '0.5rem' }}></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4rem', color: '#000' }}>
                            <div style={{ borderTop: '1px solid #000', width: '200px', textAlign: 'center', paddingTop: '0.5rem' }}>Candidate Signature</div>
                            <div style={{ borderTop: '1px solid #000', width: '200px', textAlign: 'center', paddingTop: '0.5rem' }}>Controller of Examinations</div>
                        </div>
                    </div>

                    <div style={{ padding: '1rem', borderTop: '1px solid #e2e8f0', textAlign: 'right', background: '#f7fafc', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
                        <button style={{
                            padding: '0.7rem 1.5rem', background: '#238548', color: '#fff', border: 'none', borderRadius: '6px',
                            fontWeight: 'bold', cursor: 'pointer', display: 'flex', gap: '0.5rem', alignItems: 'center', float: 'right'
                        }}>
                            🖨️ Print Admit Card
                        </button>
                        <div style={{ clear: 'both' }}></div>
                    </div>
                </div>
            </div>
        );
    };

    // ====================================================================================================
    // MAIN RENDER
    // ====================================================================================================
    return (
        <Layout role="examcell" onNavigate={onNavigate} userInfo={userInfo} activePage="examcell-admitcard">
            {notification && (
                <div style={{
                    position: 'fixed', top: '160px', right: '20px',
                    background: notification.type === 'success' ? '#238548' : '#3182ce',
                    color: '#fff', padding: '1rem 2rem', borderRadius: '8px', zIndex: 2000,
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)', animation: 'slideIn 0.3s ease'
                }}>
                    {notification.message}
                </div>
            )}
            <style>{`@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>

            {/* Page Title */}
            <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <h2 style={{ margin: 0, fontSize: '1.8rem', color: '#2d3748' }}>Admit Card Management</h2>
                    <p style={{ margin: '0.5rem 0 0', color: '#718096' }}>Generate, View and Print Student Admit Cards</p>
                </div>
            </div>

            {/* Controls & Filters */}
            <div style={{ background: '#ffffff', padding: '2rem', borderRadius: '12px', marginBottom: '2rem', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
                    <div>
                        <label style={{ display: 'block', color: '#4a5568', fontSize: '0.9rem', marginBottom: '0.5rem', fontWeight: '500' }}>Search Student</label>
                        <input
                            type="text" placeholder="Search by Roll No or Name..."
                            value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', transition: 'border-color 0.2s',
                                boxSizing: 'border-box'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#238548'}
                            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', color: '#4a5568', fontSize: '0.9rem', marginBottom: '0.5rem', fontWeight: '500' }}>Course</label>
                        <select
                            value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', cursor: 'pointer', appearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.8rem center', backgroundSize: '1em',
                                boxSizing: 'border-box'
                            }}
                        >
                            <option value="All">All Courses</option>
                            <option value="BCA">BCA</option>
                            <option value="MCA">MCA</option>
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', color: '#4a5568', fontSize: '0.9rem', marginBottom: '0.5rem', fontWeight: '500' }}>Semester</label>
                        <select
                            value={selectedSemester} onChange={(e) => setSelectedSemester(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', cursor: 'pointer', appearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.8rem center', backgroundSize: '1em',
                                boxSizing: 'border-box'
                            }}
                        >
                            <option value="All">All Semesters</option>
                            <option value="1st">1st Semester</option>
                            <option value="3rd">3rd Semester</option>
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', color: '#4a5568', fontSize: '0.9rem', marginBottom: '0.5rem', fontWeight: '500' }}>Status</label>
                        <select
                            value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', cursor: 'pointer', appearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.8rem center', backgroundSize: '1em',
                                boxSizing: 'border-box'
                            }}
                        >
                            <option value="All">All Status</option>
                            <option value="Generated">Generated</option>
                            <option value="Pending">Pending Generation</option>
                        </select>
                    </div>
                </div>

                <div style={{
                    borderTop: '1px solid #edf2f7', paddingTop: '1.5rem',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer' }} onClick={toggleSelectAll}>
                        <div style={{
                            width: '20px', height: '20px', borderRadius: '4px',
                            border: `2px solid ${isAllSelected && filteredStudents.length > 0 ? '#238548' : '#cbd5e0'}`,
                            background: isAllSelected && filteredStudents.length > 0 ? '#238548' : 'transparent',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '14px', color: '#fff'
                        }}>
                            {isAllSelected && filteredStudents.length > 0 && '✓'}
                        </div>
                        <span style={{ color: '#4a5568', fontWeight: '500', userSelect: 'none' }}>
                            Select All ({filteredStudents.length} Students)
                        </span>
                    </div>
                    <button
                        onClick={handleBulkGenerate}
                        disabled={selectedStudents.length === 0 || processingBulk}
                        style={{
                            padding: '0.8rem 1.5rem',
                            background: selectedStudents.length > 0 ? '#238548' : '#e2e8f0',
                            color: selectedStudents.length > 0 ? '#fff' : '#a0aec0',
                            border: 'none', borderRadius: '8px', cursor: selectedStudents.length > 0 ? 'pointer' : 'not-allowed',
                            fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.5rem',
                            transition: 'all 0.2s', boxShadow: selectedStudents.length > 0 ? '0 4px 6px rgba(35, 133, 72, 0.2)' : 'none'
                        }}
                    >
                        {processingBulk ? (
                            <>
                                <span style={{ animation: 'spin 1s linear infinite' }}>⌛</span> Processing...
                            </>
                        ) : (
                            <>⚡ Generate for Selected ({selectedStudents.length})</>
                        )}
                    </button>
                </div>
            </div>

            {/* Student List Table */}
            <div style={{ background: '#ffffff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '8px' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #edf2f7' }}>
                                <th style={{ padding: '1rem', width: '50px' }}></th>
                                <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Student Details</th>
                                <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Course Info</th>
                                <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Exam Center</th>
                                <th style={{ padding: '1rem 1.5rem', textAlign: 'center', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</th>
                                <th style={{ padding: '1rem 1.5rem', textAlign: 'center', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" style={{ padding: '3rem', textAlign: 'center', color: '#64748b' }}>Loading students data...</td></tr>
                            ) : filteredStudents.length === 0 ? (
                                <tr><td colSpan="6" style={{ padding: '3rem', textAlign: 'center', color: '#64748b' }}>No students found matching your filters.</td></tr>
                            ) : (
                                filteredStudents.map(student => (
                                    <tr key={student.id} style={{
                                        borderBottom: '1px solid #edf2f7',
                                        background: selectedStudents.includes(student.id) ? '#f0fdf4' : 'transparent',
                                        transition: 'background 0.2s'
                                    }}>
                                        <td style={{ padding: '1rem', textAlign: 'center' }}>
                                            <div
                                                onClick={() => toggleSelectStudent(student.id)}
                                                style={{
                                                    width: '20px', height: '20px', borderRadius: '4px', margin: '0 auto',
                                                    border: `2px solid ${selectedStudents.includes(student.id) ? '#238548' : '#cbd5e0'}`,
                                                    background: selectedStudents.includes(student.id) ? '#238548' : 'transparent',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    fontSize: '14px', color: '#fff', cursor: 'pointer'
                                                }}
                                            >
                                                {selectedStudents.includes(student.id) && '✓'}
                                            </div>
                                        </td>
                                        <td style={{ padding: '1rem 1.5rem' }}>
                                            <div style={{ fontWeight: '600', color: '#334155', fontSize: '1rem' }}>{student.name}</div>
                                            <div style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '0.25rem' }}>Roll: {student.rollNo}</div>
                                        </td>
                                        <td style={{ padding: '1rem 1.5rem' }}>
                                            <div style={{ color: '#334155' }}>{student.course}</div>
                                            <div style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '0.25rem' }}>{student.semester} Semester</div>
                                        </td>
                                        <td style={{ padding: '1rem 1.5rem', color: '#475569' }}>{student.examCenter}</td>
                                        <td style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                                            <span style={{
                                                padding: '0.35rem 0.75rem', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600',
                                                background: student.status === 'Generated' ? '#dcfce7' : '#fff7ed',
                                                color: student.status === 'Generated' ? '#166534' : '#9a3412',
                                                border: `1px solid ${student.status === 'Generated' ? '#bbf7d0' : '#ffedd5'}`
                                            }}>
                                                {student.status}
                                            </span>
                                        </td>
                                        <td style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                                            {student.status === 'Generated' ? (
                                                <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                                                    <button
                                                        onClick={() => handlePreview(student)}
                                                        style={{
                                                            padding: '0.5rem 1rem', background: '#f1f5f9', color: '#475569',
                                                            border: '1px solid #cbd5e1', borderRadius: '6px', cursor: 'pointer',
                                                            fontSize: '0.9rem', fontWeight: '500', transition: 'all 0.2s',
                                                            display: 'flex', alignItems: 'center', gap: '0.25rem'
                                                        }}
                                                        onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; }}
                                                        onMouseLeave={(e) => { e.currentTarget.style.background = '#f1f5f9'; }}
                                                    >
                                                        👁️ Preview
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    onClick={() => { toggleSelectStudent(student.id); handleBulkGenerate(); }}
                                                    style={{
                                                        padding: '0.5rem 1rem', background: '#238548', color: '#fff',
                                                        border: 'none', borderRadius: '6px', cursor: 'pointer',
                                                        fontSize: '0.9rem', fontWeight: '500', transition: 'all 0.2s',
                                                        boxShadow: '0 2px 4px rgba(35, 133, 72, 0.2)'
                                                    }}
                                                    onMouseEnter={(e) => { e.currentTarget.style.background = '#1a5a33'; }}
                                                    onMouseLeave={(e) => { e.currentTarget.style.background = '#238548'; }}
                                                >
                                                    ⚡ Generate
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {isPreviewModalOpen && <PreviewModal />}
        </Layout>
    );
};

export default ExamCellAdmitCard;
